export enum AhuDataOwnerTypes {
  WorkOrder = "workorder.WorkOrder",
  Report = "report.Report",
}
